import Swiper, { Autoplay, EffectFade } from 'swiper';
Swiper.use([Autoplay, EffectFade]);
import 'swiper/swiper-bundle.min.css';

class ProgressBarSlider {
    constructor(elem) {
        this.elem = elem;
        this.progressBar = this.elem.querySelector('.progress-bar-slider__progress');
        this.progressBarAnimationClass = 'progress-bar-slider__progress--animate';
        this.autoplaydelay = this.getDelay();
    }

    init() {
        const swiper = new Swiper(this.elem, {
            //effect: 'fade',
            //direction: 'vertical',
            speed: 800,
            loop: true,
            autoplay: {
                delay: this.autoplaydelay,
                disableOnInteraction: false,
            },
            on: {
                slideChangeTransitionStart: this.removeActiveClass.bind(this),
                slideChangeTransitionEnd: this.addActiveClass.bind(this),
            }
        });
    }

    getDelay() {
        const progressStyle = getComputedStyle(this.progressBar);
        const delayString = progressStyle.getPropertyValue('--delay');
        const delayStringWithoutUnit = delayString.replace(/[^\d.ex-]+/gi, '');
        return parseInt(delayStringWithoutUnit, 10);
    }

    removeActiveClass() {
        if (this.progressBar.classList.contains(this.progressBarAnimationClass)) {
            this.progressBar.classList.remove(this.progressBarAnimationClass);
        }
    }

    addActiveClass() {
        this.progressBar.classList.add(this.progressBarAnimationClass);
    }
}

export default ProgressBarSlider;
